module.exports = "<style></style>\n<div id=\"my_dataviz\" ></div>"